import './Calendar.scss';
import { forwardRef } from 'react';
import { Calendar as PrCalendar } from 'primereact/calendar';
import classNames from 'classnames';

const Calendar = forwardRef(({ className, panelClassName, ...props}, ref) => {

  return <PrCalendar ref={ref} className={classNames('Calendar', className)} panelClassName={classNames('CalendarPanel', panelClassName)} {...props} />

})

export default Calendar